'use client';
import React from 'react';
import Image from 'next/image';
import { trackClick } from '@/lib/analytics';

const INSTALL_URL = 'https://public.onelink.me/qC5s/e9771917';

// Shown inside an ad slot's reserved box when the slot gets no ad while it
// is on screen. Collapsing a visible slot pulls everything below it up
// (a layout shift: 0.12-0.20 CLS measured, and the cause of the desktop CLS
// regression in Search Console from 27 Aug 2026); leaving the box empty
// shows a blank band. Filling the same box with our own banner avoids both.
// Slots that are off screen when the no-fill arrives still collapse.
export function isOnScreen(el: HTMLElement | null): boolean {
  if (!el) return false;
  const rect = el.getBoundingClientRect();
  if (rect.width === 0 && rect.height === 0) return false; // display:none
  return rect.bottom > 0 && rect.top < window.innerHeight;
}

const HouseBanner: React.FC<{ variant: 'box' | 'strip' }> = ({ variant }) => {
  const isBox = variant === 'box';
  return (
    <a
      href={INSTALL_URL}
      target='_blank'
      rel='noopener noreferrer'
      onClick={() => trackClick('house_banner_install')}
      className={`flex items-center justify-center gap-3 rounded-lg border border-gray-200 bg-white text-center no-underline ${
        isBox ? 'flex-col px-4' : 'flex-row px-4'
      }`}
      style={
        isBox
          ? { width: 300, height: 250 }
          : { width: '100%', maxWidth: 728, height: 90 }
      }
    >
      <Image
        src='/_assets/icons/public_square_logo.svg'
        alt='Public App'
        width={40}
        height={40}
      />
      {/* Kept short and small on purpose: this banner appears late (after
          the ad server answers), so if its text were the largest element on
          screen it would become the page's LCP and make that metric worse. */}
      <span className='text-sm font-medium text-gray-700'>Get the Public App</span>
      <span className='shrink-0 rounded-full bg-red-500 px-4 py-1.5 text-sm font-semibold text-white'>
        Install App
      </span>
    </a>
  );
};

export default HouseBanner;
